const injectLinkInNode = (element, url) => {
  const script = document.createElement('link')
  script.setAttribute('type', 'text/css')
  script.setAttribute('rel', 'stylesheet')
  script.setAttribute('href', url)

  element?.appendChild(script)
}

export default injectLinkInNode
